export default __webpack_public_path__ + "961af73a193584c4b1396a610661c901.jpg";